import React from "react";
import { Helmet } from "react-helmet";
import TeamsComponent from "../../Components/TeamsComponent";

const Teams = () => {
  return (
    <>
      <Helmet>
        <title>
          Match Rankings | Up-to-Date Sports Rankings at cricket betting tips
        </title>
        <meta
          name="description"
          content="Stay ahead with the latest match rankings at cricket betting tips. Get real-time updates, detailed insights, and expert analysis on your favorite teams and players."
        />
      </Helmet>

      <TeamsComponent />
    </>
  );
};

export default Teams;
